import messages from '~/constants/localizations/teamStats';

export const NFL_PREGAME_OFFENSIVE = [
  {
    key: 'yards_per_game',
    meta_key: 'yards_per_game_rank',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'passing_yards_per_game',
    meta_key: 'passing_yards_per_game_rank',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'rushing_yards_per_game',
    meta_key: 'rushing_yards_per_game_rank',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'points_per_game',
    meta_key: 'points_per_game_rank',
    label: 'Points',
    localized_label: messages.football.points_per_game,
  },
  {
    key: 'third_downs_percentage',
    meta_key: 'third_downs_percentage_rank',
    label: '3rd Downs %',
    localized_label: messages.football.third_down_percentage,
  },
];

export const NFL_PREGAME_DEFENSIVE = [
  {
    key: 'yards_per_game',
    meta_key: 'total_yards_rank',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'passing_yards_per_game',
    meta_key: 'passing_yards_rank',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'rushing_yards_per_game',
    meta_key: 'rushing_yards_rank',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'points_per_game',
    meta_key: 'points_per_game_rank',
    label: 'Points',
    localized_label: messages.football.points_per_game,
  },
  {
    key: 'third_downs_percentage',
    meta_key: 'third_downs_percentage_rank',
    label: '3rd Downs %',
    localized_label: messages.football.third_down_percentage,
  },
];

export const NFL = [
  {
    key: 'first_downs_number',
    label: 'First Downs',
    localized_label: messages.football.first_downs,
  },
  {
    key: ['third_down_made', 'third_down_attempts'],
    format: (made, attempts) => `${made} - ${attempts}`,
    percentage: 'third_down_percent',
    label: '3rd Down Efficiency',
    localized_label: messages.football.third_downs_efficiency,
  },
  {
    key: ['fourth_down_made', 'fourth_down_attempts'],
    format: (made, attempts) => `${made} - ${attempts}`,
    percentage: 'fourth_down_percent',
    label: '4th Down Efficiency',
    localized_label: messages.football.fourth_downs_efficiency,
  },
  {
    key: 'rushing_yards',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'passing_net_yards',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'net_yards',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'sacks',
    label: 'Sacks (Yards)',
    meta_key: 'sack_yards',
    localized_label: messages.football.sack_yards,
  },
  {
    key: 'passing_interceptions',
    label: 'Interceptions Thrown',
    localized_label: messages.football.interceptions_thrown,
  },
  {
    key: 'punting_punts',
    meta_key: 'punting_average',
    label: 'Punts (Average)',
    localized_label: messages.football.punting_average,
  },
  {
    key: 'penalties',
    meta_key: 'penalty_yards',
    label: 'Penalties (Yards)',
    localized_label: messages.football.penalty_yards,
  },
  {
    key: 'fumbles',
    meta_key: 'fumbles_lost',
    label: 'Fumbles (Lost)',
    localized_label: messages.football.fumbles_lost,
  },
  {
    key: 'time_in_possession',
    percentage: 'time_of_possession_minutes',
    label: 'Possession',
    localized_label: messages.football.possession,
  },
];
